'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

exports.AppStatus = void 0;
(function(AppStatus2) {
  AppStatus2["UPCOMING"] = "upcoming";
  AppStatus2["PREMIUM"] = "premium";
  AppStatus2["BETA"] = "beta";
  AppStatus2["FEATURED"] = "featured";
})(exports.AppStatus || (exports.AppStatus = {}));
//# sourceMappingURL=types.cjs.js.map
